import { defineStore } from 'pinia';
import { ref } from 'vue';
import { config } from '../utils/config';

export interface WidgetConfig {
  id: string;
  title: string;
  avatarUrl: string;
  loginRequired: boolean;
  initialFormFields?: Array<{
    id: string;
    label: string;
    required: boolean;
    type: 'text' | 'email' | 'phone';
  }>;
  theme?: {
    primaryColor?: string;
    accentColor?: string;
    backgroundColor?: string;
    bubbleColor?: string;
  };
}

export const useChatConfigStore = defineStore('chatConfig', () => {
  // State
  const widgetId = ref<string | null>(null);
  const widgetTitle = ref<string>('Orbitar Assistant');
  const widgetAvatarUrl = ref<string>('');
  const loginRequired = ref(false);
  const initialFormFields = ref<WidgetConfig['initialFormFields']>([]);
  const theme = ref<WidgetConfig['theme']>({});

  // Actions
  const fetchWidgetConfig = async (id: string) => {
    try {
      // In a real application, this would be an API call
      // Mock API call to the backend using the config
      const apiUrl = `${config.apiUrl}/api/widgets/${id}`;
      console.log(`[Orbitar Chat] Fetching widget config from: ${apiUrl}`);
      
      // For now, simulate a response
      const mockResponse: WidgetConfig = {
        id,
        title: 'Orbitar Assistant',
        avatarUrl: '',
        loginRequired: false,
        initialFormFields: [],
        theme: {
          primaryColor: '#7986CB',
          accentColor: '#81D4FA',
          backgroundColor: '#F0FAFB',
        },
      };
      
      // Store the configuration
      widgetId.value = mockResponse.id;
      widgetTitle.value = mockResponse.title;
      widgetAvatarUrl.value = mockResponse.avatarUrl;
      loginRequired.value = mockResponse.loginRequired;
      initialFormFields.value = mockResponse.initialFormFields || [];
      theme.value = mockResponse.theme || {};
      
      return mockResponse;
    } catch (error) {
      console.error('[Orbitar Chat] Error fetching widget config:', error);
      throw error;
    }
  };

  return {
    widgetId,
    widgetTitle,
    widgetAvatarUrl,
    loginRequired,
    initialFormFields,
    theme,
    fetchWidgetConfig,
  };
}); 